import { render, staticRenderFns } from "./GiftManager.vue?vue&type=template&id=5724dd38"
import script from "./GiftManager.vue?vue&type=script&lang=js"
export * from "./GiftManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/rouvenpajewski/Documents/Projekte/kuipers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5724dd38')) {
      api.createRecord('5724dd38', component.options)
    } else {
      api.reload('5724dd38', component.options)
    }
    module.hot.accept("./GiftManager.vue?vue&type=template&id=5724dd38", function () {
      api.rerender('5724dd38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/vue/GiftManager.vue"
export default component.exports